<template>
  <div class="personallist">
    <div v-for="(item, index) in list" :key="index" class="article">
      <div class="main_message" @click="viewDetail(item.artical_id)">
        <div class="group">
          {{ item.group_name }}第{{ item.period_id }}期（{{ item.province }}）
        </div>
        <div class="main_title">
          <div class="name">
            {{ item.title }}
          </div>
          <div class="left_icon"></div>
        </div>
        <score :rankNum="item.star" :thumb="item.thumb"></score>
        <div class="success_status" v-if="item.process_status === 4"></div>
      </div>
      <div class="extra_message">
        <div :class="['message', `message_${item.process_status}`]">
          {{ item.extra_message }}
        </div>
        <div
          :class="`btn btn_${item.otms_status}`"
          v-if="item.otms_status === 1"
          @click="clickBtn(item)"
        >
          领取奖励
        </div>
        <div
          :class="`btn btn_${item.otms_status}`"
          v-if="item.otms_status === 2"
          @click="clickBtn(item)"
        >
          查看物流
        </div>
        <!--        <div :class="`btn btn_${item.button}`" v-if="item.button === 3" @click="clickBtn(item)">-->
        <!--          去查看-->
        <!--        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import Score from '../components/score'
export default {
  name: 'PersonalList',
  components: {
    Score
  },
  data() {
    return {
      list: []
    }
  },
  created() {
    this.personallist()
  },
  methods: {
    async personallist() {
      const that = this
      const res = await that.$api.getPersonallist()
      if (res.code === 0) {
        // 接口返回缺少：作文名称
        that.list = res.data.list
      } else {
        that.$toast(res.msg || '获取往期美文失败')
      }
    },
    viewDetail(id) {
      const that = this
      that.$xesLogger.clickMsg({
        params: { clickid: '51.1.0', elemname: '往期征文查看详情', articleId: id }
      })
      that.$router.push({
        name: 'articleDetail',
        query: {
          articleId: id,
          isSelf: 1
        }
      })
    },
    // 按钮点击 领取奖励/去查看/查看物流
    clickBtn(item) {
      const that = this
      that.$xesLogger.clickMsg({
        params: { clickid: '51.0.0', elemname: '往期征文按钮点击', button: item.otms_status }
      })
      switch (item.otms_status) {
        case 1:
          that.$router.push({
            name: 'addAddress',
            query: {
              recordId: item.record_id,
              periodId: item.period_id
            }
          })
          break
        case 2: {
          window.location.href = `https://h5.xueersi.com/5ffff88db4ce0d733d35e26c.html?orderNum=${item.otms_order_num}`
          break
        }
        default:
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
.personallist {
  min-height: 100vh;
  padding: 12px;
  background: #f7f7f8;

  .article {
    width: 351px;
    padding: 0 16px;
    margin-bottom: 12px;
    font-weight: 400;
    //height: 144px;
    font-family: PingFangSC-Regular, PingFang SC;
    background: #fff;
    border-radius: 12px;

    .main_message {
      position: relative;
      padding: 16px 0;

      .group {
        font-size: 13px;
        color: #999;
      }

      .name {
        margin: 12px 0 8px;
        overflow: hidden;
        font-size: 17px;
        font-weight: 500;
        white-space: nowrap;
        color: #333;
        text-overflow: ellipsis;
      }
    }

    .extra_message {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 9px 0;
      border-top: 1px solid rgba(247, 247, 248, 1);

      .message {
        font-size: 13px;
        color: #999;
      }
      // 评审中
      //.message_2 {
      //  color: #e02727;
      //}
      // 已入围
      .message_4 {
        color: #be8243;
      }

      .btn {
        width: 76px;
        height: 28px;
        font-size: 13px;
        line-height: 28px;
        text-align: center;
        border-radius: 16px;
      }

      .btn_1 {
        color: #fff;
        background: #e02727;
      }

      .btn_2 {
        color: #333;
        border: 1px solid rgba(153, 153, 153, 0.4);
      }

      .btn_3 {
        color: #333;
        border: 1px solid rgba(153, 153, 153, 0.4);
      }
    }

    .main_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .left_icon {
      width: 12px;
      height: 12px;
      padding: 5px;
      margin-top: 3px;
      background-image: url('../assets/images/apply/left_icon.png');
      background-size: cover;
      background-repeat: no-repeat;
    }

    .success_status {
      position: absolute;
      top: 21px;
      right: 27px;
      width: 57px;
      height: 57px;
      background-image: url('../assets/apply/sucess_icon.png');
      background-size: cover;
      background-repeat: no-repeat;
    }
  }
}
</style>
